import Button from '@/features/shared/Button';
import { Theme } from '@/utils/constants';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import clsx from 'clsx';
import React from 'react';
import { IUnauthorizedMessageProps } from './UnauthorizedMessage.interfaces';
import useUnauthorizedMessageStyles from './UnauthorizedMessage.styles';

const UnauthorizedMessage = ({
  firstMessageLabel,
  secondMessageLabel,
  actionButtonLabel,
  actionButtonUrl,
  variant = 'page',
  severity = 'info',
}: IUnauthorizedMessageProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useUnauthorizedMessageStyles();
  const isHeader = React.useRef(variant === 'header');

  return (
    <div
      className={clsx(
        classes.root,
        isMobile && isHeader.current ? classes.layoutMobile : classes.layout,
        isHeader.current && classes.layoutHeader,
      )}
    >
      <Alert variant="outlined" severity={severity} className={classes.alert}>
        <div className="message-section">
          <div className={classes.messageWrapper}>
            <AlertTitle>{firstMessageLabel || '< First message here >'}</AlertTitle>
            {secondMessageLabel || '< Second message here >'}
          </div>
          {actionButtonLabel && actionButtonUrl && (
            <Button outlined theme={Theme.dark} link={{ href: actionButtonUrl } as LinkType}>
              {actionButtonLabel}
            </Button>
          )}
        </div>
      </Alert>
    </div>
  );
};

export default UnauthorizedMessage;
